// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import Loading from 'components/loading/loading';
// Lazy-loaded Components
const CertificateList = lazy(() => import('pages/certificate/CertificateList'));

const CertificateRoute = (
  <Route path={routeName.certificate}>
    <Route
      index
      element={
        <PrivateRoute name={[PrivateRouteConst.CERTIFICATE_VIEW]}>
          <Suspense fallback={<Loading />}>
            <CertificateList />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default CertificateRoute;
